export default class MenuPositionBaseService {
	constructor(anchorService) {
		this._anchorService = anchorService;
	}
}
